<template>
  <sweet-modal ref="modal">
    <h1>User Db</h1>
    <p>
      <select class="form-control" id="merges" v-model.number="selectedIndex">
        <option :value="-1"></option>
        <option
          v-for="(element, index) in mergeTagsSources"
          :key="index"
          :value="index"
        >
          {{ element.name }}
        </option>
      </select>
    </p>

    <template #button>
      <button
        class="btn btn-default right-margin"
        id="close-button"
        @click="close"
      >
        {{ $t('modals.close_button') }}
      </button>
      <button
        class="btn btn-primary"
        id="save-tag-source"
        @click="saveTagSource"
      >
        {{ $t('modals.save_button') }}
      </button>
    </template>
  </sweet-modal>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import {SweetModal} from 'sweet-modal-vue-3';

export default {
  name: 'MergeTagsSourcesModal',
  components: {
    SweetModal
  },
  data() {
    return {
      selectedMergeTagsSource: null,
      selectedTemplate: {},
      selectedIndex: -1
    };
  },
  computed: {
    ...mapState({
      mergeTagsSources: state => state.mergeTagsSources
    })
  },
  methods: {
    ...mapMutations(['setSuccess']),
    ...mapActions(['assignMergeTagsSource']),
    open(template) {
      this.setSuccess(false);
      this.selectedTemplate = template;

      if (template.mergeTagsSource) {
        this.selectedIndex = this.mergeTagsSources.findIndex(
          e =>
            e.extended.userDbId === template.mergeTagsSource.extended.userDbId
        );
      } else {
        this.selectedIndex = -1;
      }

      this.selectedMergeTagsSource =
        this.selectedIndex === -1
          ? null
          : this.mergeTagsSources[this.selectedIndex];

      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
    },
    saveTagSource() {
      if (
        this.selectedMergeTagsSource !== null &&
        !this.mergeTagsSources.find(
          m => m.id === this.selectedMergeTagsSource.id
        )
      ) {
        this.selectedMergeTagsSource = null;
      }

      this.assignMergeTagsSource({
        templateId: this.selectedTemplate.id,
        mergeTagsSource: this.selectedMergeTagsSource
      });
      this.close();
    }
  },
  watch: {
    selectedIndex(newIndex) {
      this.selectedMergeTagsSource =
        newIndex === -1 ? null : this.mergeTagsSources[newIndex];
    }
  }
};
</script>

<style scoped>
.right-margin {
  margin-right: 1em;
}
</style>
